export enum SnackType {
  PreparedFood = 'Prepared Food',
  SweetsAndDessert = 'Sweets & Dessert',
  Beverages = 'Beverages',
  Fruits = 'Fruits',
  Vegetable = 'Vegetable',
  AsianFood = 'Asian Food'
}
  